export default {
    API: "/estrava/api",
    versionAPI: 1
}